import { render } from "./EecInvestigationRegistry.vue?vue&type=template&id=4a4ef9b4&scoped=true"
import script from "./EecInvestigationRegistry.vue?vue&type=script&lang=js"
export * from "./EecInvestigationRegistry.vue?vue&type=script&lang=js"

import "./EecInvestigationRegistry.vue?vue&type=style&index=0&id=4a4ef9b4&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4ef9b4"]])

export default __exports__